import React from 'react';

// Рендер юридического документа: заголовок, дата редакции, разделы с пунктами
// и (для оферты) таблица реквизитов. Текст живёт отдельно в src/lib/legal/ —
// правки юриста вносятся в одном месте и не задевают вёрстку.
export default function LegalPage({ title, date, sections, requisites, requisitesTitle }) {
  return (
    <article className="mx-auto max-w-3xl px-4 py-10 font-montserrat">
      <h1 className="text-2xl sm:text-3xl font-bold">{title}</h1>
      <p className="mt-2 text-sm text-paper-ink-3">{date}</p>

      <div className="mt-8 space-y-8">
        {sections.map((section, i) => (
          <section key={section.title || `s${i}`}>
            {section.title && <h2 className="text-lg font-bold mb-3">{section.title}</h2>}
            <div className="space-y-3 text-paper-ink-2 text-sm leading-relaxed">
              {section.items.map((item) => <p key={item}>{item}</p>)}
            </div>
          </section>
        ))}

        {requisites && (
          <section>
            <h2 className="text-lg font-bold mb-3">{requisitesTitle}</h2>
            <dl className="text-sm text-paper-ink-2">
              {requisites.map(([label, value]) => (
                <div key={label} className="flex flex-col sm:flex-row sm:gap-4 py-1.5 border-b border-paper-line">
                  <dt className="sm:w-64 shrink-0 text-paper-ink-3">{label}</dt>
                  <dd className="break-all">{value}</dd>
                </div>
              ))}
            </dl>
          </section>
        )}
      </div>
    </article>
  );
}
